import { useQuery } from '@tanstack/react-query';
import { CardOpportunityProps } from '../../interface/secondaries';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useGetIntermediations = (page: number = 1, limit: number = 10) => {
  return useQuery({
    queryKey: ['secondaries', 'intermediations', page, limit],
    queryFn: () => getIntermediations(page, limit),
  });
};

const getIntermediations = async (page: number, limit?: number) => {
  const { data } = await api.get<IntermediationsResponse>(
    apiConfig.routes.secondaries.intermadiations,
    { params: { page, limit } }
  );
  return data;
};

type IntermediationsResponse = {
  data: CardOpportunityProps[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: string;
    total: number;
  };
};
